let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("TDsGN")).then(() => parcelRequire('81n0o'));